'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'cannon';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e642';
var svgPathData = ['M91.8 386.1c-27.6-55.3-5.3-122.5 49.9-150.2 23.1-11.1 92.7-37.4 172.4-66.3 78.9-28.6 165-58.9 218.6-77.7 15-5.2 31.6 1.4 38.8 15.9l30.7 61.4c7.2 14.5 2.6 31.8-10.6 40.6-23.5 15.8-54.2 36.3-87.7 58.5-26.2-27.4-63.1-44.4-104-44.4-79.5 0-144 64.5-144 144 0 19.2 3.7 37.4 10.5 54.2-10.4 6.3-18.8 11.1-24.6 14.1-55.3 27.5-122.5 5.1-150.1-50.2z', 'M266.5 422.2c-10.4 6.3-18.8 11.1-24.6 14.1-55.3 27.5-122.5 5.1-150.1-50.2s-5.3-122.5 49.9-150.2c23.1-11.1 92.7-37.4 172.4-66.3 78.9-28.6 165-58.9 218.6-77.7 15-5.2 31.6 1.4 38.8 15.9l30.7 61.4c7.2 14.5 2.6 31.8-10.6 40.6-23.5 15.8-54.2 36.3-87.7 58.5 7.4 7.7 13.9 16.3 19.5 25.5 32.9-21.9 62.9-41.9 86-57.4 26.7-17.9 35.7-52.7 21.4-81.5L600.2 93.5c-14.4-28.7-47.7-42.4-78-31.8-107.4 37.6-345.1 121.5-394.6 145.5-50.6 25.3-79.7 76.3-79.6 129.3l-12.6 6.3C3.8 358.6-9.1 397 6.8 428.6S61 473 92.6 457.2l12.6-6.3c42.3 31.9 100.6 39.1 151.2 13.8 6.1-3.2 14.8-8.1 25.4-14.5-6.1-8.7-11.2-18.2-15.3-28.1zM80.7 427.4l-2.4 1.2c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l2.4-1.2c2.5 10.3 6.2 20.4 11.1 30.2s10.8 18.9 17.5 27zM320 368a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm192 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM400 392a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCannon = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;